<template>
  <div id="medkon-word-cloud">
    <div class="row mb-1">
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 px-gap">
        <div id="wordcloud-container-medkon" class="widget-12 card card-default widget-loader-circle shade">
          <div class="card-body" style="min-height: 520px">
            <div class="row">
              <div class="col-lg-8 col-md-8 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Kamus Kata</h4>
                  <p class="small hint-text">kamus Kata Media Online</p>
                </div>
              </div>
              <div class="col-lg-4 col-md-4" align="right">
                <div class="form-check form-check-inline switch m-t-20">
                  <input type="checkbox" id="tampil-tabel" @click="is_table = !is_table" />
                  <label for="tampil-tabel">Tampilkan Tabel</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12" id="wordcloud-medkon">
                <div v-if="!word_cloud && !is_wordcloud_loading" class="alert alert-danger" id="errorApiEl" role="alert"
                  align="center">
                  <strong>Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <div class="row" v-else>
                  <div v-if="is_table" class="col-md-2" />
                  <table-dynamic-component v-if="is_table" :data_head="table_wordcloud_head" :data_head_class="[
                    { head: 'Frekuensi', class: 'text-center' },
                  ]" :data_body="table_wordcloud_body" table_class="table-stripped" :config="table_wordcloud_conf"
                    :key="table_word_cloud_key" class="col-md-8" />
                  <div v-else class="col-lg-12 col-md-12">
                    <div class="d-flex align-items-center">
                      <span>Tampilkan</span>
                      <select id="select-word-count" class="rounded mx-1 form-control-sm form-custom"
                        v-model="word_cloud_items" @change="getWordCloud()">
                        <option value="20">20 Data</option>
                        <option value="50">50 Data</option>
                        <option value="100">100 Data</option>
                        <option value="300">300 Data</option>
                      </select>
                      <span>dari Kamus Kata</span>
                    </div>
                    <loader-component v-if="is_wordcloud_loading" class="mt-5" />
                    <div v-else>
                      <word-cloud-chart-component :key="word_cloud_key" :dataset="word_cloud"
                        :id="'wordcloud-medkon'" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loader_component from "@/views/components/loader.vue";
import word_cloud_chart from "@/views/components/chart/word_cloud_chart.vue";
import table_dynamic from "@/views/components/table_dynamic.vue";

export default {
  name: "medkon_word_cloud",
  components: {
    "loader-component": loader_component,
    "word-cloud-chart-component": word_cloud_chart,
    "table-dynamic-component": table_dynamic,
  },
  props: {
    filter_tier: {
      type: String,
      default: () => {
        return "0";
      },
    },
  },
  data() {
    return {
      id_project: this.$store.getters.user.id_project,
      selected_tier: this.filter_tier,
      is_table: false,
      word_cloud: null,
      word_cloud_key: 50,
      word_cloud_items: 300,
      is_wordcloud_loading: true,
      table_word_cloud_key: 100,
      table_wordcloud_head: ["Kata", "Frekuensi"],
      table_wordcloud_body: null,
      table_wordcloud_conf: {
        language: {
          thousands: ".",
          search: "Cari kata:",
          info: "Menampilkan halaman _PAGE_ dari _PAGES_",
          infoEmpty: "Menampilkan 0 data",
          lengthMenu: "Tampilkan _MENU_ data",
        },
        pageLength: 5,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        aaSorting: [[1, "desc"]],
      },
      wordcloud_topik: false,
    };
  },
  mounted() {
    this.getWordCloud();
  },
  methods: {
    tierChange(tier) {
      this.selected_tier = tier;
      this.getWordCloud();
    },
    getWordCloud: function () {
      let self = this;
      self.is_wordcloud_loading = true;
      var params = this.$route.query;
      params.items = 300;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (query != "") {
        let api =
          process.env.VUE_APP_API_URL +
          "wordcloud/" +
          this.id_project +
          "?tipe=medkon&" +
          query;
        this.$http
          .get(api)
          .then(function (response) {
            if (response.status != 204) {
              self.word_cloud = response.data.wordcloud;
              self.wordcloud_medkon_key++;
              self.assembleWordcloudTabel(response.data.wordcloud);
            } else {
              self.word_cloud = null;
              self.wordcloud_medkon_key++;
            }
          })
          .catch(function (err) {
            console.log(err);
          })
          .finally(function () {
            self.is_wordcloud_loading = false;
          });
      }
    },
    assembleWordcloudTabel: function (dataset) {
      let tabel_body = [];
      for (let data in dataset) {
        let row = [];
        row[0] = data;
        row[1] = `<center>${dataset[data]}</center>`;
        tabel_body.push(row);
      }
      this.table_wordcloud_body = tabel_body;
      this.wordcloud_table_key++;
    },
  },
  watch: {
    $route() {
      this.getWordCloud();
    },
  },
};
</script>
